<template>
  <v-container fluid class="pa-0 pb-8">
    <v-container class="container-custom" v-if="!updateBannerStatus">
      <Breadcrumbs
        :title="$t('modules.messaging.banners.update.breadcrumbs.title')"
        :description="$t('modules.messaging.banners.update.breadcrumbs.description')"
      ></Breadcrumbs>
      <v-row>
        <v-col class="viewSpace" sm="6">
          <OutlinedCard
            :title="$t('modules.messaging.banners.update.mainData.title')"
            :subtitle="$t('modules.messaging.banners.update.mainData.subtitle')"
            :switch-label="(status) ? $t('enabled') : $t('disabled')"
            :switch-value="status"
            @switchChange="switchStatus"
            switcher
            class="mb-6"
          >
            <v-row dense class="pb-2">
              <v-col sm="6">
                <v-text-field
                  :error-messages="($v.description.$dirty && $v.description.$invalid) ?
                  ((!$v.description.required) ? $t('modules.messaging.banners.validations.nameRequired') :
                  (!$v.description.alphaNumWithSpaces) ? $t('modules.messaging.banners.validations.nameAlphanumericWithSpaces') :
                  $t('modules.messaging.banners.validations.nameMaxLength')) :
                  ''"
                  v-model="$v.description.$model"
                  @blur="$v.description.$touch()"
                  @keypress="$validateAlphanumeric($event, $v.description.$model,60, true)"
                  ref="description"
                  :label="`${$t('modules.messaging.banners.update.mainData.labels.name')} *`"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col sm="3">
                <v-text-field
                  :error-messages="($v.code.$dirty && $v.code.$invalid) ?
                  ((!$v.code.required) ? $t('modules.messaging.banners.validations.codeRequired') :
                  (!$v.code.alphaNum) ? $t('modules.messaging.banners.validations.codeAlphanumeric') :
                  (!$v.code.maxLength) ? $t('modules.messaging.banners.validations.codeMaxLength') :
                  $t('modules.messaging.banners.validations.codeUnique')) :
                  ''"
                  v-model="$v.code.$model"
                  @blur="validateCode"
                  @keypress="$validateAlphanumeric($event, $v.code.$model,20)"
                  ref="code"
                  :loading="loadingCode"
                  :label="`${$t('modules.messaging.banners.update.mainData.labels.code')} *`"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col sm="3">
                <v-text-field
                  :error-messages="($v.order.$dirty && $v.order.$invalid) ?
                  ((!$v.order.minValue) ? $t('modules.messaging.banners.validations.orderMinValue') :
                  (!$v.order.numeric) ? $t('modules.messaging.banners.validations.orderNumeric') :
                  $t('modules.messaging.banners.validations.orderRequired')) : ''"
                  v-model="$v.order.$model"
                  @blur="$v.order.$touch()"
                  ref="order"
                  type="number"
                  :label="`${$t('modules.messaging.banners.create.mainData.labels.order')} *`"
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col sm="6">
                <v-menu
                  v-model="menuFrom"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  bottom
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs  }">
                    <v-text-field
                      v-model="from"
                      :label="$t('modules.messaging.banners.update.mainData.labels.fromDate')"
                      append-icon="mdi-calendar"
                      readonly
                      outlined
                      v-on="on"
                      v-bind="attrs"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="from"
                    color="primary"
                    :min="(()=>(new Date().toISOString().substr(0, 10)))()"
                    :max="(()=>(to ? shiftDate(to, false) : null))()"
                    @input="menuFrom=false"
                  >
                    <v-spacer></v-spacer>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col sm="6">
                <v-menu
                  v-model="menuTo"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  bottom
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="to"
                      :label="$t('modules.messaging.banners.update.mainData.labels.toDate')"
                      append-icon="mdi-calendar"
                      readonly
                      outlined
                      v-on="on"
                      v-bind="attrs"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="to"
                    color="primary"
                    :min="(()=>(from ? shiftDate(from, true) : shiftDate(new Date(), true)))()"
                    @input="menuTo=false"
                  >
                    <v-spacer></v-spacer>
                  </v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </OutlinedCard>
          <OutlinedCard
            :title="$t('modules.messaging.banners.update.bannerDesign.title')"
          >
            <v-select
              :error-messages="($v.bannerType.$dirty && $v.bannerType.$invalid) ?
              $t('modules.messaging.banners.validations.bannerTypeRequired') : ''"
              v-model="$v.bannerType.$model"
              @blur="$v.bannerType.$touch()"
              ref="bannerType"
              :label="$t('modules.messaging.banners.update.bannerDesign.bannerType.label')"
              :items="bannerTypes"
              :placeholder="$t('modules.messaging.banners.update.bannerDesign.bannerType.placeholder')"
              class="my-6"
              outlined
              item-text="meaning"
            ></v-select>
            <v-expansion-panels
              v-if="bannerType == '273'"
              v-model="openedPanel"
              class="banner--expansion-panels"
              accordion
              focusable
            >
              <v-expansion-panel ref="title comment">
                <v-expansion-panel-header>{{ $t('modules.messaging.banners.update.bannerDesign.headers.text') }}</v-expansion-panel-header>
                <v-expansion-panel-content class="pt-6">
                  <v-text-field
                    :error-messages="($v.title.$dirty && $v.title.$invalid) ?
                    ((!$v.title.required) ? $t('modules.messaging.banners.validations.titleRequired') :
                    $t('modules.messaging.banners.validations.titleMaxLength')) :
                    ''"
                    v-model="$v.title.$model"
                    @blur="$v.title.$touch()"
                    class="pb-2"
                    outlined
                    :label="`${$t('modules.messaging.banners.update.bannerDesign.labels.mainText')} *`"
                  ></v-text-field>
                  <v-text-field
                    :error-messages="($v.comment.$dirty && $v.comment.$invalid) ?
                    $t('modules.messaging.banners.validations.commentMaxLength') : ''"
                    v-model="$v.comment.$model"
                    @blur="$v.comment.$touch()"
                    class="pt-2"
                    outlined
                    :label="$t('modules.messaging.banners.update.bannerDesign.labels.secondaryText')"
                  ></v-text-field>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header>{{ $t('modules.messaging.banners.update.bannerDesign.headers.background') }}</v-expansion-panel-header>
                <v-expansion-panel-content class="pt-5">
                  <div class="d-lg-flex align-center">
                    <div class="col-lg-6">
                      {{ $t('modules.messaging.banners.update.bannerDesign.labels.backgroundColor') }}
                      <v-color-picker
                        v-model="color"
                        mode="hexa"
                        hide-mode-switch
                      ></v-color-picker>
                    </div>
                    <v-divider
                      class="mx-3 d-none d-lg-block"
                      vertical
                    ></v-divider>
                    <DropFiles
                      class="font-size-x-small text-center"
                      :extension="'.jpg, .png'"
                      :type-file="'image/*'"
                      :limit-size-bytes="'500000'"
                      :clear-validation.sync="clearDropFileValidation"
                      :show-title="false"
                      :show-dashed="true"
                      :size="'x-sm'"
                      :file-input.sync="bgImg"
                      @remove="bgImg = null"
                    >
                    </DropFiles>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel ref="img">
                <v-expansion-panel-header>{{ $t('modules.messaging.banners.update.bannerDesign.headers.images') }}</v-expansion-panel-header>
                <v-expansion-panel-content class="pt-5">
                  <div class="d-md-flex">
                    <DropFiles
                      class="font-size-x-small text-center"
                      :extension="'.jpg, .png'"
                      :type-file="'image/*'"
                      :limit-size-bytes="'500000'"
                      :required="$v.img.$anyError"
                      :clear-validation.sync="clearDropFileValidation"
                      :show-title="false"
                      :show-dashed="true"
                      :size="'x-sm'"
                      :file-input.sync="img"
                      @remove="img = null"
                    >
                    </DropFiles>
                    <v-divider
                      class="mx-4 d-none d-md-block"
                      vertical
                    ></v-divider>
                    <div class="pt-4 pt-md-0">
                      {{ $t('modules.messaging.banners.update.bannerDesign.labels.imagePosition') }}
                      <v-radio-group
                        v-model="imagePosition"
                        hide-details
                      >
                        <v-radio
                          :label="$t('modules.messaging.banners.update.bannerDesign.labels.left')"
                        >
                        </v-radio>
                        <v-radio
                          :label="$t('modules.messaging.banners.update.bannerDesign.labels.right')"
                        >
                        </v-radio>
                      </v-radio-group>
                      <v-checkbox
                        class="mt-2"
                        v-model="imageCorner"
                        :label="$t('modules.messaging.banners.update.bannerDesign.labels.corner')"
                      >
                      </v-checkbox>
                    </div>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel ref="groups">
                <v-expansion-panel-header>{{ $t('modules.messaging.banners.update.bannerDesign.headers.buttons') }}</v-expansion-panel-header>
                <v-expansion-panel-content class="pt-5 mb-n4">
                  <MultipleFormGroup
                    ref="groups"
                    class="banner--multipleFormGroup"
                    :items="$v.groups.$each.$iter"
                    :length="groups.length"
                    @addGroup="addGroup"
                    @removeGroup="removeGroup"
                    :canAddGroup="addGroupStatus"
                  >
                    <template v-slot:default="{item}">
                      <v-container fluid class="pa-0">
                        <v-row class="pt-2" no-gutters>
                          <v-col class="pb-0 pr-1" sm="6">
                            <v-text-field
                              :error-messages="(item.text.$dirty && item.text.$invalid) ?
                              ((!item.text.required) ? $t('modules.messaging.banners.validations.buttonTextRequired') :
                              (!item.text.alphaNumWithSpaces) ? $t('modules.messaging.banners.validations.buttonTextAlphanumericWithSpaces') :
                              $t('modules.messaging.banners.validations.buttonTextMaxLength', {maxLength})) :
                              ''"
                              v-model="item.text.$model"
                              @blur="item.text.$touch()"
                              @keypress="$validateAlphanumeric($event, item.text.$model, maxLength, true)"
                              outlined
                              :label="$t('modules.messaging.banners.update.bannerDesign.labels.buttonTitle')"
                            ></v-text-field>
                          </v-col>
                          <v-col class="pb-0 pl-1" sm="6">
                            <v-text-field
                              :error-messages="(item.link.$dirty && item.link.$invalid) ?
                              ((!item.link.required) ? $t('modules.messaging.banners.validations.buttonLinkRequired') :
                              $t('modules.messaging.banners.validations.buttonLinkMaxLength')) :
                              ''"
                              v-model="item.link.$model"
                              @blur="item.link.$touch()"
                              outlined
                              :label="$t('modules.messaging.banners.update.bannerDesign.labels.buttonLink')"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-container>
                    </template>
                  </MultipleFormGroup>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <div v-if="bannerType == '274'">
              <DropFiles
                class="font-size-small text-center"
                :extension="'.jpg, .png, .gif'"
                :type-file="'image/*'"
                :limit-size-bytes="'1000000'"
                :required="$v.gif.$anyError"
                :clear-validation.sync="clearDropFileValidation"
                :show-title="false"
                :show-dashed="true"
                :size="'sm'"
                :file-input.sync="$v.gif.$model"
                @remove="gif = null"
              >
              </DropFiles>
              <v-text-field
                :error-messages="($v.bannerLink.$dirty && $v.bannerLink.$invalid) ?
                ((!$v.bannerLink.required) ? $t('modules.messaging.banners.validations.bannerLinkRequired') :
                $t('modules.messaging.banners.validations.bannerLinkMaxLength')) :
                ''"
                v-model="$v.bannerLink.$model"
                @blur="$v.bannerLink.$touch()"
                ref="bannerLink"
                class="pt-8"
                outlined
                :label="$t('modules.messaging.banners.update.bannerDesign.labels.bannerLink')"
              ></v-text-field>
            </div>
          </OutlinedCard>
          <div class="d-flex justify-end">
            <Button
              white
              :text="$t('actions.cancel')"
              @clicked="$router.replace('/messaging/banners')"
              @end="resetButtonValues"
              class="mr-4"
            ></Button>
            <Button
              :loading="updateButton.loading"
              :success="updateButton.success"
              :error="updateButton.error"
              :text="$t('actions.save')"
              :successText="$t('actions.created')"
              :errorText="$t('actions.error')"
              :disabled="!canUpdate"
              @end="resetButtonValues"
              @clicked="updateBanner"
            ></Button>
          </div>
        </v-col>
        <v-col sm="6" class="pt-5 pr-13">
          <OutlinedCard
            class="sticky"
            :title="$t('modules.messaging.banners.update.banner.preview')"
          >
            <generic-banner :banner="banners" class="transform"></generic-banner>
            <!-- <v-img class="gif" :src="banners.image.src" v-if="bannerType == '274'"></v-img> -->
          </OutlinedCard>
        </v-col>
      </v-row>
    </v-container>
    <SuccessMessage
      v-else
      :type="successMessage.type"
      :title="successMessage.title"
      :actionPrimary="successMessage.actionPrimary"
      :actionSecondary="successMessage.actionSecondary"
    />
  </v-container>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs/Breadcrumbs';
import OutlinedCard from '@/components/OutlinedCard/OutlinedCard';
import Button from '@/components/Button/Button';
import SuccessMessage from '@/components/SuccessMessage/SuccessMessage';
import MultipleFormGroup from '@/components/MultipleFormGroup/MultipleFormGroup';
import GenericBanner from '../Components/GenericBanner';
import DropFiles from '../Components/DropFiles';
import {required, alphaNum, maxLength, helpers, requiredUnless, requiredIf, numeric, minValue} from 'vuelidate/lib/validators';
import {$banners, $types} from '../Services';
import moment from 'moment';
import Colors from '@/constants/colors';
import { mapGetters } from 'vuex';

export default {
  name: 'BannersUpdate',
  components: {
    Breadcrumbs,
    OutlinedCard,
    Button,
    SuccessMessage,
    MultipleFormGroup,
    GenericBanner,
    DropFiles
  },
  data() {
    return {
      description: '',
      code: null,
      originalCode: null,
      codeUnique: true,
      loadingCode: false,
      status: true,
      order: null,
      originalOrder: null,
      color: '',
      type: {},
      bannerType: '',
      bannerTypes: [
        {
          text: '',
          value: '273'
        },
        {
          text: '',
          value: '274'
        }
      ],
      menuFrom: false,
      menuTo: false,
      from: '',
      to: '',
      gif: null,
      img: null,
      bgImg: null,
      title: '',
      comment: '',
      imagePosition: 0,
      imageCorner: false,
      bannerLink: '',
      groups: [
        {
          text: this.$t('modules.messaging.banners.update.banner.text'),
          link: ''
        }
      ],
      addGroupStatus: true,
      openedPanel: null,
      panelValidation: {
        'title': 0,
        'comment': 0,
        'img': 2,
        'groups': 3
      },
      clearDropFileValidation: false,
      updateBannerStatus: false,
      updateButton: {
        loading: false,
        success: false,
        error: false
      },
      successMessage: {
        type: null,
        title: null,
        actionPrimary: null,
        actionSecondary: null
      },
    };
  },
  computed: {
    canUpdate() {
      return this.$permissions.portaladministrativo.messaging.banners.UPDATE;
    },
    banners() {
      return {
        color: this.color,
        bgImg: this.bgImg ? this.bannerBaseURL+this.bgImg : null,
        image: {
          src: this.img ? this.bannerBaseURL+this.img : require('@/assets/placeholder.png'),
          position: this.imagePosition,
          corner: this.imageCorner,
        },
        type: this.type,
        text: [this.title, this.comment],
        button: this.groups
      }
    },
    maxLength() {
      let max
      switch (this.groups.length) {
        case 1: max = 10; break;
        case 2: max = 10; break;
        case 3: max = 10; break;
      }
      return max
    },
    isManualBannerType() {
      return this.bannerType == '273'
    },
    ...mapGetters({
      bannerBaseURL: 'commons/getAssetsURL'
    }),
  },
  async mounted() {
    this.setPrimaryColor()
    await this.getType()
    this.fetchBanner()
  },
  methods: {
    async fetchBanner() {
      const {data} = await $banners.findById(this.$route.params.id);
      this.status = data.visible;
      this.code = data.code;
      this.originalCode = data.code;
      this.description = data.description;
      this.order = data.order;
      this.originalOrder = data.order;
      this.from = data.dateFrom
      this.to = data.dateTo
      this.bannerType = data.type.value;
      this.title = data.title;
      this.type = data.type;
      this.comment = data.comment;
      this.color = data.color;
      const {fileUrl: imgFile,  corner, position} = data.images.find(image => !image.background)
      this.img = imgFile
      // this.img = this.base64ToFile(imgFile, imgFileName)
      this.imageCorner = corner
      this.imagePosition = position
      if (data.images.some(image => image.background)) {
        const {fileUrl: bgImgFile } = data.images.find(image => image.background)
        this.bgImg = bgImgFile
      }
      this.groups = [];
      data.buttons.forEach(button => {
        this.groups.push({
          text: button.text,
          link: button.link
        });
      });
      if (this.bannerType == '274') {
        const {fileUrl: gifFile } = data.images.find(image => !image.background)
        this.gif =  gifFile
        // this.gif =  this.base64ToFile(gifFile, gifFileName)
        this.bannerLink = data.buttons[0].link
      }
    },
    setPrimaryColor() {
      this.color = this.$isTeclab ? Colors.teclab.primary.base : Colors.ipp.primary.base
    },
    async getType() {
      try {
        const banTypes = await $types.find(null, null, {
          params: { type: 'BANNER_TYPE'}
        });
        this.bannerTypes = banTypes.data
      } catch (error) {
        this.bannerTypes = [];
          throw error;
      }
    },
    switchStatus(val) {
      this.status = val
      if(!this.status) this.order = null
    },
    loadGif() {
      return this.gif;
    },
    shiftDate(date, add) {
      return add ? moment(date).add(1, 'days').toISOString().substr(0, 10) :
        moment(date).subtract(1, 'days').toISOString().substr(0, 10)
    },
    base64ToFile(base64data, fileName) {
      const bs = atob(base64data);
      const buffer = new ArrayBuffer(bs.length);
      const ba = new Uint8Array(buffer);
      for (let i = 0; i < bs.length; i++) {
        ba[i] = bs.charCodeAt(i);
      }
      return new File([ba], fileName);
    },
    async validateCode() {
      this.$v.code.$touch();
      if (this.$v.code.$model) {
        if (this.originalCode === this.code) {
          this.codeUnique = true;
          return;
        }
        this.codeUnique = null;
        this.loadingCode = true;
        try {
          const response = await $banners.find('exists', null, {params: {code: this.$v.code.$model}});
          this.codeUnique = !response.data.exists;
          this.loadingCode = false;
        } catch (error) {
          this.codeUnique = null;
          throw error;
        } finally {
          this.$v.code.$touch();
        }
      }
    },
    addGroup() {
      const mockup =
        {
          text: '',
          link: ''
        }
      this.groups.push({
        ...mockup
      });
      this.addGroupStatus = this.groups.length < 3;
    },
    removeGroup(index) {
      this.groups.splice(index, 1);
      this.addGroupStatus = true;
    },
    async updateBanner() {
      this.updateButton.loading = true;
      this.clearDropFileValidation = true
      try {
        if (this.$v.$invalid || !this.codeUnique) {
          this.$v.$touch();
          if (!this.codeUnique) {
            this.$refs.code.$el.scrollIntoView({block: 'center', behavior: 'smooth'});
          } else {
            Object.keys(this.$v).some(input => {
              if (input.includes('$')) return false;
              if (this.$v[input].$error) {
                Object.keys(this.$refs).some(ref => {
                  if (ref.includes(input)) {
                    if(input in this.panelValidation) {
                      this.openedPanel = this.panelValidation[input]
                    } else {
                      this.openedPanel = null
                    }
                    this.$refs[ref][0]
                      ? this.$refs[ref][0].$el.scrollIntoView({block: 'center', behavior: 'smooth'})
                      : this.$refs[ref].$el.scrollIntoView({block: 'center', behavior: 'smooth'});
                  }
                })
                return true;
              }
            });
          }
          this.updateButton.error = true;
          this.updateButton.loading = false;
        } else {
          const formData = new FormData();
          let model;
          if (this.bannerType == '273') {
            model = {
              visible: this.status,
              code: this.code,
              description: this.description.trim(),
              color: this.color,
              type: {value:this.bannerType},
              order: this.order,
              dateFrom: this.from,
              dateTo: this.to || null,
              title: this.title,
              comment: this.comment,
              images:
                this.bgImg ? [
                  {
                    fileName: this.img.name,
                    position: this.imagePosition,
                    corner: this.imageCorner,
                    background: false,
                  },
                  {
                    fileName: this.bgImg.name,
                    position: 0,
                    corner: false,
                    background: true
                  }
                ] : [
                  {
                    fileName: this.img.name,
                    position: this.imagePosition,
                    corner: this.imageCorner,
                    background: false,
                  }
                ],
              buttons: this.groups
            }
            if (this.bgImg) {
              formData.append('banner', this.bgImg)
              formData.append('banner', this.img)
            } else {
              formData.append('banner', this.img)
            }
          } else {
            model = {
              code: this.code,
              description: this.description.trim(),
              visible: this.status,
              order: this.order,
              dateFrom: this.from,
              dateTo: this.to || null,
              type: {value:this.bannerType},
              color: this.color,
              title: '',
              comment: '',
              images: [
                {
                  fileName: this.gif.name,
                  position: 0,
                  corner: false,
                  background: false,
                }
              ],
              buttons: [
                {
                  text: '',
                  link: this.bannerLink
                }
              ]
            }
            formData.append('banner', this.gif)
          }
          formData.append('model', JSON.stringify(model))
          formData.append('bannerId', this.$route.params.id)
          await $banners.formData(formData, 'update')
          this.successMessage.type = 'success';
          this.successMessage.title = this.$t('modules.messaging.banners.update.successMessage.title');
          this.successMessage.actionPrimary = {
            text: this.$t('actions.close'), callback: () => {
              this.$router.push('/messaging/banners');
            }
          };
          this.updateBannerStatus = true;
          this.updateButton.success = true;
          this.updateButton.loading = false;
        }
      } catch (error) {
        this.successMessage.type = 'error';
        this.successMessage.title = this.$t('modules.messaging.banners.update.errorMessage.title');
        this.successMessage.actionPrimary = {
          text: this.$t('actions.return'), callback: () => {
            this.updateBannerStatus = false;
          }
        };
        this.successMessage.actionSecondary = null;
        this.updateBannerStatus = true;
        this.updateButton.loading = false;
        this.updateButton.error = true;
        throw error;
      }
    },
    resetButtonValues() {
      this.updateButton.loading = false;
      this.updateButton.success = false;
      this.updateButton.error = false;
    },
  },
  validations: {
    description: {
      required,
      maxLength: maxLength(60),
      alphaNumWithSpaces: helpers.regex('withSpace', /^[a-z0-9]*(?:[a-z0-9]+\s[a-z0-9]*)*$/i)
    },
    code: {
      required,
      alphaNum,
      maxLength: maxLength(20),
      unique() {
        return this.codeUnique != false;
      },
    },
    order: {
      required,
      numeric,
      minValue: minValue(0)
    },
    bannerType: { required },
    title: {
      required: requiredIf('isManualBannerType'),
      maxLength: maxLength(65)
    },
    comment: {
      maxLength: maxLength(120)
    },
    img: { required: requiredIf('isManualBannerType') },
    gif: { required: requiredUnless('isManualBannerType') },
    bannerLink : {
      maxLength: maxLength(120)
    },
    groups: {
      $each:
        {
          text: {
            required: requiredIf('isManualBannerType'),
            alphaNumWithSpaces: helpers.regex('withSpace', /^[a-zá-úñ0-9]*(?:[a-zá-úñ0-9]+\s[a-zá-úñ0-9]*)*$/i),
            maxLength(value) {
              let max
              switch (this.groups.length) {
                case 1: max = 10; break
                case 2: max = 10; break
                case 3: max = 10; break
              }
              return max >= value.length
            }
          },
          link: {
            required: requiredIf('isManualBannerType'),
            maxLength: maxLength(120)
          }
        }
    }
  }
};
</script>

<style lang="sass" scoped>
.viewSpace
  padding-top: 20px !important
  padding-bottom: 20px !important
  padding-left: 50px !important

.sticky
  position: sticky
  top: 20px
  height: 400px

.transform
  transform-origin: top
  transform: scale(1.2)

.font-size-x-small
  font-size: x-small

.font-size-small
  font-size: small

.gif
  cursor: pointer
  max-height: 300px
</style>

<style lang="sass">
.banner--multipleFormGroup
  > .multipleFormGroup__form-group
    width: 90%
    > .multipleFormGroup__form-group__content
      width: 97%

.banner--expansion-panels
  > .v-expansion-panel
    > .v-expansion-panel-header
      background-color: #F7F7F7
      border-color: #D0D0D0
      color: #939393
    > .v-expansion-panel-header--active
      background-color: #F2FAFE
      color: #46494A
      &:before
        opacity: 0 !important
      &:hover
        background-color: #F0EFEF
</style>

